const actions = {
  SET_STATE: 'via/SET_STATE',
  GET_PROJECTS: 'via/GET_PROJECTS',
  REFRESH_DETAILS: 'VIA/REFRESH_DETAILS',
  DAILY_DATA_FEED: 'VIA/DAILY_DATA_FEED',
}

export default actions
